import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Rahul Rathnavel logo</title>
    <polygon
      fill="none"
      stroke="currentColor"
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
      points="42 2 5 23 5 68 42 90 79 68 79 23"
    />
    <text
      x="42"
      y="61"
      textAnchor="middle"
      fill="currentColor"
      fontFamily="var(--font-mono)"
      fontSize="34"
      fontWeight="700">
      R
    </text>
  </svg>
);

export default IconLogo;
